import { Fragment } from 'react'
import Group from 'components/utils/Group'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Divider from 'LuxKit/Divider'
import { fillArray } from 'lib/array/arrayUtils'

interface Props {
  daysCount: number
}

function ItineraryLoadingState(props: Props) {
  const { daysCount } = props

  return (
    <Group direction="vertical" gap={16}>
      <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center" fullWidth>
        <TextLoadingBox width="30%" typography="heading5" />
        <TextLoadingBox width="20%" typography="body-medium" />
      </Group>
      <Group direction="vertical" gap={12}>
        {fillArray(daysCount).map((dayIndex) => (
          <Fragment key={dayIndex}>
            {dayIndex > 0 && <Divider kind="secondary" />}
            <Group direction="horizontal" gap={12} verticalAlign="center" fullWidth>
              <TextLoadingBox width="25%" typography="body-medium" />
              <TextLoadingBox width="50%" typography="body-medium" />
            </Group>
          </Fragment>
        ))}
      </Group>
    </Group>
  )
}

export default ItineraryLoadingState
